import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { WorkshopNotesStoreEffects } from './effects';
import { NotesDialogsModule } from 'app/workshop/notes/dialogs/dialogs.module';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('workshop-notes', reducer),
        EffectsModule.forFeature([WorkshopNotesStoreEffects]),
        NotesDialogsModule
    ],
    providers: [],
})
export class WorkshopNotesStoreModule { }
